import React from "react";

import INFO from "../../data/user";

import Accordion from "../accordion/accordion";
import "./styles/experienceList.css";

const ExperienceList = () => {
	return (
		<div className="works-list">
			{INFO.works.map((work, index) => (
				<Accordion key={index} work={work} />
			))}
		</div>
	);
};

export default ExperienceList;
